import { COLORS } from "@asayinc/component-library";

const FormSectionDivider = () => (
  <div style={{ height: "1px", width: "100%", background: COLORS.P_OUTLINE }} />
);

export default FormSectionDivider;
